import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const DropsOverviewPage = lazy(
  () =>
    import('./DropsOverviewPage.eager').then(mod => ({
      default: mod.DropsOverviewPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
